import { useEffect, useMemo, useRef } from "react";
import { observer } from "mobx-react-lite";

import type { AudioRecordingSnapshot } from "@/store/audio-capture/coordinator";

export interface RecordingPlaybackProps {
  snapshot: AudioRecordingSnapshot;
}

const buildAudioUrl = (snapshot: AudioRecordingSnapshot) => {
  if (!snapshot.audioBlobs.length) return null;
  const blob = new Blob(
    snapshot.audioBlobs.map(entry => entry.blobData),
    {
      type: "audio/webm",
    }
  );
  return URL.createObjectURL(blob);
};

export const RecordingPlayback = observer(({ snapshot }: RecordingPlaybackProps) => {
  const audioUrl = useMemo(() => buildAudioUrl(snapshot), [snapshot]);
  const previousUrlRef = useRef<string | null>(null);

  useEffect(() => {
    const previousUrl = previousUrlRef.current;
    previousUrlRef.current = audioUrl;

    return () => {
      if (previousUrl) {
        URL.revokeObjectURL(previousUrl);
      }
    };
  }, [audioUrl]);

  useEffect(() => {
    return () => {
      if (previousUrlRef.current) {
        URL.revokeObjectURL(previousUrlRef.current);
        previousUrlRef.current = null;
      }
    };
  }, []);

  if (!audioUrl) {
    return null;
  }

  return (
    <audio controls src={audioUrl} style={{ width: "100%", marginTop: "1rem" }}>
      Your browser does not support audio playback.
    </audio>
  );
});

export default RecordingPlayback;
